import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: '#1e2247',
    borderRadius: 16,
    boxShadow: '0 24px 48px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.06)',
    padding: theme.spacing(4),
    width: '420px',
    maxHeight: '80vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column' as const,
    outline: 'none',
  },
  itemList: {
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
    paddingRight: 4,
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.15)',
      borderRadius: 3,
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  },
  title: {
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.15rem',
    letterSpacing: '0.01em',
  },
  subtitle: {
    color: 'rgba(255, 255, 255, 0.75)',
    fontSize: '0.8rem',
    marginTop: 2,
  },
  closeButton: {
    color: 'rgba(255, 255, 255, 0.75)',
    padding: 6,
    '&:hover': {
      color: '#fff',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  assetRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    borderRadius: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    border: '1px solid rgba(255, 255, 255, 0.06)',
    transition: 'all 0.15s ease',
    '& > *': {
      marginRight: theme.spacing(2),
    },
    '& > *:last-child': {
      marginRight: 0,
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
  input: {
    flex: 1,
    '& .MuiInputBase-input': {
      color: '#fff',
      fontSize: '0.875rem',
      padding: '10px 12px',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.85)',
      fontSize: '0.85rem',
      '&.Mui-focused': {
        color: '#7c8aff',
      },
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '& fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.12)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.25)',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#7c8aff',
        borderWidth: 1,
      },
    },
  },
  defaultButton: {
    borderRadius: 8,
    padding: 6,
    color: 'rgba(255, 255, 255, 0.8)',
    transition: 'all 0.15s ease',
    '&:hover': {
      color: '#7c8aff',
      backgroundColor: 'rgba(124, 138, 255, 0.08)',
    },
  },
  defaultButtonActive: {
    borderRadius: 8,
    padding: 6,
    color: '#7c8aff',
    '&:hover': {
      backgroundColor: 'rgba(124, 138, 255, 0.12)',
    },
  },
  deleteButton: {
    color: 'rgba(255, 255, 255, 0.6)',
    padding: 6,
    borderRadius: 8,
    transition: 'all 0.15s ease',
    '&:hover': {
      color: '#ff6b6b',
      backgroundColor: 'rgba(255, 107, 107, 0.1)',
    },
  },
  addButton: {
    width: '100%',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    borderRadius: 10,
    padding: '12px 16px',
    textTransform: 'none',
    fontSize: '0.85rem',
    fontWeight: 500,
    color: 'rgba(255, 255, 255, 0.8)',
    borderColor: 'rgba(255, 255, 255, 0.1)',
    borderStyle: 'dashed',
    transition: 'all 0.15s ease',
    '&:hover': {
      color: '#7c8aff',
      borderColor: 'rgba(124, 138, 255, 0.3)',
      backgroundColor: 'rgba(124, 138, 255, 0.06)',
    },
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  cancelButton: {
    marginRight: theme.spacing(2),
    borderRadius: 10,
    padding: '8px 24px',
    textTransform: 'none',
    fontSize: '0.85rem',
    fontWeight: 500,
    color: 'rgba(255, 255, 255, 0.85)',
    borderColor: 'rgba(255, 255, 255, 0.12)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.25)',
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
    },
  },
  saveButton: {
    borderRadius: 10,
    padding: '8px 32px',
    textTransform: 'none',
    fontSize: '0.85rem',
    fontWeight: 600,
    backgroundColor: '#7c8aff',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(124, 138, 255, 0.3)',
    '&:hover': {
      backgroundColor: '#6b7bff',
      boxShadow: '0 4px 12px rgba(124, 138, 255, 0.4)',
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(124, 138, 255, 0.3)',
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 2),
    color: 'rgba(255, 255, 255, 0.7)',
    textAlign: 'center' as const,
  },
  emptyIcon: {
    fontSize: 40,
    marginBottom: theme.spacing(1.5),
    color: 'rgba(255, 255, 255, 0.5)',
  },
  emptyText: {
    fontSize: '0.85rem',
    lineHeight: 1.5,
  },
  errorMessage: {
    color: '#ff6b6b',
    fontSize: '0.8rem',
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    backgroundColor: 'rgba(255, 107, 107, 0.08)',
    border: '1px solid rgba(255, 107, 107, 0.15)',
  },
  rowIndex: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: '0.75rem',
    fontWeight: 600,
    minWidth: 20,
    textAlign: 'center' as const,
  },
}));
